import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { formatTimeNumber } from 'server/shared/helpers/time';
import {
  PartialAcceptTime,
  PartialAcceptTimesInput,
} from 'server/shared/models/partialAcceptTime';
import { Shift } from 'server/shared/models/shift';

@Component({
  selector: 'partial-accept-dialog',
  templateUrl: 'partial-accept-dialog.html',
  styleUrls: ['partial-accept-dialog.scss'],
})
export class PartialAcceptDialog {
  times: PartialAcceptTimesInput[] = [];
  fromInvalid = false;
  toInvalid = false;

  constructor(
    public dialogRef: MatDialogRef<PartialAcceptDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: { shifts: Shift[]; partialTimes: PartialAcceptTime[] },
  ) {
    if (data.partialTimes.length) {
      data.partialTimes.forEach((shift) => {
        const partialTime = {
          shift: shift.shift,
          to: formatTimeNumber(shift.to),
          from: formatTimeNumber(shift.from),
          initialTo: shift.to,
          initialFrom: shift.from,
        };
        this.times.push(partialTime);
      });
    } else {
      data.shifts.forEach((shift) => {
        const partialTime = {
          shift: shift.shift,
          to: formatTimeNumber(shift.to),
          from: formatTimeNumber(shift.from),
          initialTo: shift.to,
          initialFrom: shift.from,
        };
        this.times.push(partialTime);
      });
    }
  }

  validateTimes() {
    this.times.forEach((time, index) => {
      const from = Number.parseInt(time.from.replace(':', ''), 10);
      const to = Number.parseInt(time.to.replace(':', ''), 10);
      this.fromInvalid = formatTimeNumber(from) == 'Invalid';
      this.toInvalid = formatTimeNumber(to) == 'Invalid';

      if (from === to) {
        this.fromInvalid = true;
        this.toInvalid = true;
      }

      if (
        !time.initialFrom ||
        !time.initialTo ||
        this.fromInvalid ||
        this.toInvalid
      ) {
        return;
      }
      if (time.initialFrom < time.initialTo) {
        if (from < time.initialFrom || to > time.initialTo || from > to) {
          this.fromInvalid = true;
          this.toInvalid = true;
        }
      } else {
        if (
          (from < time.initialFrom && from > time.initialTo) ||
          (to < time.initialFrom && to > time.initialTo) ||
          (from > time.initialFrom && from > to && to >= time.initialFrom) ||
          (from < time.initialFrom && to < from) ||
          (from < time.initialFrom && to > time.initialTo)
        ) {
          this.fromInvalid = true;
          this.toInvalid = true;
        }
      }
    });
  }

  save(e?: Event): void {
    if (this.fromInvalid || this.toInvalid) {
      e?.preventDefault();
      return;
    }
    const partialTimes: PartialAcceptTime[] = [];
    this.times.forEach((time, index) => {
      const from = Number.parseInt(time.from.replace(':', ''), 10);
      const to = Number.parseInt(time.to.replace(':', ''), 10);
      this.fromInvalid = formatTimeNumber(from) == 'Invalid';
      this.toInvalid = formatTimeNumber(to) == 'Invalid';

      partialTimes.push({
        from: from,
        to: to,
        shift: time.shift,
      });
    });

    this.dialogRef.close(partialTimes);
  }
}
